import axios from 'axios'
import { useUserStore } from '@/stores/user'

const apiBase = 'https://ncht.bz'

function http() {
  const userStore = useUserStore()
  return axios.create({
    baseURL: `${apiBase}/api/wisdom-admin`,
    headers: {
      Authorization: `Bearer ${userStore.token}`,
    },
  })
}

export const wisdomAdminApi = {
  meta: () => http().get('/meta'),
  list: (params) => http().get('/lessons', { params }),
  gaps: (params) => http().get('/lessons/gaps', { params }),
  get: (id) => http().get(`/lessons/${id}`),
  update: (id, payload) => http().put(`/lessons/${id}`, payload),
  uploadCover: (id, file) => {
    const body = new FormData()
    body.append('file', file)
    return http().post(`/lessons/${id}/cover`, body)
  },
}
